import React from "react";
import "./Templates.css";

const TableTemp = () => {
  return (
    <>
      <div className="table-container" style={{ margin: "0" }}>
        <table>
          <tbody>
            <tr
              className="template flex-space-evenly align- end"
              style={{ padding: "5px", backgroundColor: "#f5f5f5" }}
            >
              <th>
                <div className="header-th"></div>
              </th>
              <th>
                <div className="header-th"></div>
              </th>
              <th>
                <div className="header-th"></div>
              </th>
              <th>
                <div className="header-th"></div>
              </th>
              <th>
                <div className="header-th"></div>
              </th>
              <th>
                <div className="header-th"></div>
              </th>
            </tr>
          </tbody>
          <tbody className="table-cells-container template">
            <tr>
              <td style={{ padding: "5px" }}>
                <img
                  className="team-profile-pic"
                  style={{ backgroundColor: "#e0e0e0" }}
                ></img>
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px" }}>
                <img
                  className="team-profile-pic"
                  style={{ backgroundColor: "#e0e0e0" }}
                ></img>
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px" }}>
                <img
                  className="team-profile-pic"
                  style={{ backgroundColor: "#e0e0e0" }}
                ></img>
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px" }}>
                <img
                  className="team-profile-pic"
                  style={{ backgroundColor: "#e0e0e0" }}
                ></img>
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px" }}>
                <img
                  className="team-profile-pic"
                  style={{ backgroundColor: "#e0e0e0" }}
                ></img>
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px" }}>
                <img
                  className="team-profile-pic"
                  style={{ backgroundColor: "#e0e0e0" }}
                ></img>
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px" }}>
                <img
                  className="team-profile-pic"
                  style={{ backgroundColor: "#e0e0e0" }}
                ></img>
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px" }}>
                <img
                  className="team-profile-pic"
                  style={{ backgroundColor: "#e0e0e0" }}
                ></img>
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px" }}>
                <img
                  className="team-profile-pic"
                  style={{ backgroundColor: "#e0e0e0" }}
                ></img>
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px" }}>
                <img
                  className="team-profile-pic"
                  style={{ backgroundColor: "#e0e0e0" }}
                ></img>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};
export default TableTemp;
